<template>
  <CloseCircleButtonModal
    class="usage-instruction-modal"
    title-text="ギフトの利用方法"
    @clicked-modal-cover="onClickModalCover"
    @clicked-close="onClickCloseButton"
  >
    <HeadingThree>{{ usageInstructionTitle }}</HeadingThree>
    <div class="usage-instruction-modal__description">
      <TextWithLinks
        :text="usageInstructionDescription"
        link-class="usage-instruction-modal__link"
      />
    </div>
  </CloseCircleButtonModal>
</template>

<script>
import CloseCircleButtonModal from '../../molecules/modals/CloseCircleButtonModal.vue'
import HeadingThree from '../../atoms/headlines/HeadingThree.vue'
import TextWithLinks from '../../atoms/text/TextWithLinks.vue'

export default {
  components: {
    CloseCircleButtonModal,
    HeadingThree,
    TextWithLinks
  },
  props: {
    usageInstructionTitle: {
      type: String,
      required: true
    },
    usageInstructionDescription: {
      type: String,
      required: true
    }
  },
  methods: {
    onClickModalCover() {
      this.$emit('clicked-modal-cover')
    },
    onClickCloseButton() {
      this.$emit('clicked-close')
    }
  }
}
</script>
<style lang="scss" scoped>
.usage-instruction-modal {
  :deep(.close-circle-button-modal__content) {
    max-height: calc(100vh - 96px);
  }

  :deep(.close-circle-button-modal__body) {
    overflow-y: auto;
  }

  &__heading {
    @extend %subhead-bold;
    color: $black;
    padding-left: 12px;
    width: 100%;
    border-left: 2px solid $primary;
    box-sizing: border-box;
  }

  &__description {
    @extend %body;
    color: $black;
    white-space: pre-wrap;
    line-height: 1.6;
    letter-spacing: 0.28px;
  }

  &__link {
    color: $link;
    word-break: break-all;
  }
}
</style>
